import React from 'react';
import { FacetOption } from '@reverbdotcom/commons';
import SearchButton from './search_button';
import { RCButton } from '@reverbdotcom/commons/src/rc/RCButton';
import classNames from 'classnames';
import { MARKETPLACE_LINK_PARAMS_BY_TRANSLATION_KEY } from './homepage/homepage_category_search_helpers';
import { MParticleEventName } from '../elog/mparticle_types';
import I18n from 'i18n-js';

interface IProps {
  categoryTranslationKey: string;
  selectedSubfilterTranslationKey: string;
  setSubfilter: Function;
}

export default function HomepageSearchFilters(props: IProps) {
  const filtersToDisplay = Object.entries(MARKETPLACE_LINK_PARAMS_BY_TRANSLATION_KEY[props.categoryTranslationKey]);
  const marketplaceLinkParams = MARKETPLACE_LINK_PARAMS_BY_TRANSLATION_KEY[props.categoryTranslationKey][props.selectedSubfilterTranslationKey] || {};
  const translatedCategory = I18n.t(`commons.homepage.categorySearch.${props.categoryTranslationKey}`);

  const searchClickEvent = {
    componentName: 'SearchButton',
    eventName: MParticleEventName.ClickedHomepageCategorySearchButton,
    category: translatedCategory,
    subfilterLabel: props.selectedSubfilterTranslationKey,
  };

  return (
    <div className="homepage-search-filters__container">
      <div className="homepage-search-filters__filters">
        {filtersToDisplay.map(f => {
          const subfilterTranslationKey = f[0];

          return (
            <HomepageFilterOption
              key={subfilterTranslationKey}
              subfilterTranslationKey={subfilterTranslationKey}
              selectedSubfilterTranslationKey={props.selectedSubfilterTranslationKey}
              setSubfilter={props.setSubfilter}
            />
          );
        })}
      </div>

      <div className="homepage-search-filters__search-button">
        <SearchButton
          categoryLabel={translatedCategory}
          marketplaceLinkParams={marketplaceLinkParams}
          clickEvent={searchClickEvent}
        />
      </div>
    </div>
  );
}

interface SelectFacetProps {
  subfilterTranslationKey: string;
  selectedSubfilterTranslationKey: string;
  setSubfilter: Function;
}

function HomepageFilterOption(props: SelectFacetProps) {
  const selected = props.subfilterTranslationKey === props.selectedSubfilterTranslationKey;

  const onClick = () => {
    props.setSubfilter(props.subfilterTranslationKey);
  };

  const classes = classNames(
    'homepage-filter-option',
    { 'homepage-filter-option--selected': selected },
  );

  return (
    <FacetOption
      active={selected}
    >
      <div className={classes}>
        <RCButton
          variant="secondary"
          onClick={onClick}
        >
          {I18n.t(`commons.homepage.categorySearch.${props.subfilterTranslationKey}`)}
        </RCButton>
      </div>
    </FacetOption>
  );
}
